// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","AppLogo":"App_AppLogo__VFm8u","App-logo-spin":"App_App-logo-spin__1up6W","AppHeader":"App_AppHeader__qxGqX","AppLink":"App_AppLink__G49XM"};